/** HTML DOM (Document Object Model) helper. */
export class DomHelper {
  public static isAnchor(el: Nil<HTMLElement>): el is HTMLAnchorElement {
    return !!el && el instanceof HTMLAnchorElement;
  }

  public static isDescendantClicked(clickE: React.MouseEvent | MouseEvent): boolean {
    const currentEl = clickE.currentTarget as Nil<HTMLElement>;
    const targetEl = clickE.target as Nil<HTMLElement>;
    if (clickE.type !== "click" || !currentEl || !targetEl) {
      return false;
    }
    return currentEl.contains(targetEl);
  }

  public static isAnchorDescendantClicked(clickE: React.MouseEvent | MouseEvent): boolean {
    return (
      this.isAnchor(clickE.currentTarget as Nil<HTMLElement>) && this.isDescendantClicked(clickE)
    );
  }
}
